import styled from '@emotion/styled/macro';
import { theme } from 'styles/theme';

export const FieldErrorMessage = styled.div`
  margin-top: 4px;
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.danger};
`;
